import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { PipesModule } from '@draeger-academy/common';
import { DaButtonModule } from '../da-button';
import { DaLinkModule } from '../da-link';
import { DaProgressiveImageModule } from '../da-progressive-image';
import { SmallImageBox } from './small-image-box.component';

@NgModule({
    declarations: [SmallImageBox],
    exports: [SmallImageBox],
    imports: [CommonModule, PipesModule, DaLinkModule, DaButtonModule, DaProgressiveImageModule]
})
export class SmallImageBoxModule {
    constructor() {}
}
